import { Key, KeyLabels } from "../container/Menu"

export function useDisplayValue({
  values,
  category,
  displayKeyValuePairs,
}: {
  values: Key[]
  category: string
  displayKeyValuePairs: KeyLabels
}) {
  let value

  if (values.length > 1) value = `${values.length} ${category}`
  else if (values.length == 1) value = displayKeyValuePairs[values[0]] ?? ""
  else value = ""

  return value
}
